import { render, staticRenderFns } from "./ObjektiCard2Tab-2-Dodatno.vue?vue&type=template&id=1da0cace&scoped=true&"
import script from "./ObjektiCard2Tab-2-Dodatno.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-2-Dodatno.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da0cace",
  null
  
)

export default component.exports